import { InputFieldData, InputStateProps } from '../@types/input-field-data';
import AgreeToTermsInput from './form-input/agree-to-terms-input';
import EmailInput from './form-input/email-input';
import FullNameInput from './form-input/full-name-input';
import PhoneNumberInput from './form-input/phone-number-input';
import TextInput from './form-input/text-input';
import ZipCodeInput from './form-input/zip-code-input';

const getComponentMap = (): Record<string, (InputProps) => JSX.Element> => ({
  agree_to_terms: AgreeToTermsInput,
  email: EmailInput,
  full_name: FullNameInput,
  phone_number: PhoneNumberInput,
  text: TextInput,
  zip_code: ZipCodeInput,
});

/**
 * Component to render a known form input component, based on the type in the props.
 */
function FormInput(props: InputFieldData & InputStateProps) {
  const componentMap = getComponentMap();

  if (Object.keys(componentMap).includes(props.type)) {
    const Component = componentMap[props.type];
    return <Component {...props} />;
  }

  // TODO: We should be warned if an unexpected input type is received
  return null;
}

export default FormInput;
